<div class="onboarding-page-progress">
  <div class="onboarding-page-progress__step onboarding-page-progress__step--filled">
    <div class="onboarding-page-progress__step-content">
      <p>{{'onboarding.progress.step1.title'|transloco}}</p>
    </div>
  </div>
  <div class="onboarding-page-progress__step">
    <div class="onboarding-page-progress__step-content">
      <p>{{'onboarding.progress.step2.title'|transloco}}</p>
    </div>
  </div>
</div>
